import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import Approuter from "./Routes/Approuter";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./assets/scss/main.scss";
import "./assets/css/material.css";
import { ApolloClient, ApolloLink, InMemoryCache, ApolloProvider, Observable, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { SERVER_URL } from "./databucket";
import { Provider } from "react-redux";
import store from "./store";
import { RingCentralProvider } from "./RingCentralProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import LoadingBar, { startLoading, endLoading } from "./components/LoadingBar";

// Top loading bar: fires startLoading() on every Apollo and axios request, endLoading()
// when it completes (success, error, or unsubscribe). The LoadingBar component renders
// only when there are active requests. Replaces the old full-screen spinner that blocked
// the UI on every fetch.
const loadingLink = new ApolloLink((operation, forward) => {
  startLoading();
  return new Observable((observer) => {
    let finished = false;
    const finish = () => { if (!finished) { finished = true; endLoading(); } };
    const sub = forward(operation).subscribe({
      next: (val) => observer.next(val),
      error: (err) => { finish(); observer.error(err); },
      complete: () => { finish(); observer.complete(); },
    });
    return () => { finish(); sub.unsubscribe(); };
  });
});

axios.interceptors.request.use(
  (config) => { startLoading(); return config; },
  (error) => { endLoading(); return Promise.reject(error); }
);
axios.interceptors.response.use(
  (response) => { endLoading(); return response; },
  (error) => { endLoading(); return Promise.reject(error); }
);

const httpLink = createHttpLink({
     uri: SERVER_URL + '/graphql/',
});

// Add token to headers using authLink
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      "x-app-platform": "WEB",               // ✅ FLAT HEADER
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});
export const client = new ApolloClient({
  link: ApolloLink.from([loadingLink, authLink, httpLink]),
  cache: new InMemoryCache(),
  credentials: "include",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <RingCentralProvider>
        <ApolloProvider client={client}>
          <LoadingBar />
          <Approuter />
        </ApolloProvider>
      </RingCentralProvider>
    </Provider>
  </ErrorBoundary>
);
